<mat-form-field appearance="fill" class="w-full mt-2">
  <mat-label>{{ 'Project' | transloco }}</mat-label>
  <mat-select
    (infiniteScroll)="loadAllOnScroll()"
    (selectionChange)="emitSelection($event.value)"
    [(value)]="dummyValue"
    msInfiniteScroll
    [compareWith]="compareProjects"
    (keydown)="$event.key === 'Enter' ? $event.stopPropagation() : null"
  >
    <ngx-mat-select-search
      #singleSelect
      [formControl]="searchControl"
      [placeholderLabel]="'Search' | transloco"
      [noEntriesFoundLabel]="'No result found' | transloco"
      (keydown)="$event.key === 'Enter' ? $event.stopPropagation() : null"
    ></ngx-mat-select-search>
    <ng-container *ngFor="let project of projectReportService.allProjects">
      <mat-option [value]="project" *ngIf="checkException(project.id)">
        {{ project.name | titlecase }}
      </mat-option>
    </ng-container>
    <mat-option *ngIf="loading" class="flex flex-col items-center loaderOption">
      <mat-spinner *ngIf="loading" [diameter]="20" class="m-3"></mat-spinner>
    </mat-option>
  </mat-select>
  <!--  <mat-error *ngIf="required">-->
  <!--    {{ 'Please fill in all required fields.' | transloco }}-->
  <!--  </mat-error>-->
</mat-form-field>
